import React, { Fragment, memo, ReactNode } from 'react'
import { SvgIcon, Tooltip, Typography } from '@mui/material'
import { Columns3Minor } from '@shopify/polaris-icons'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props {
  disabled: boolean
  columnName: string
  children: ReactNode
}

const ColumnHiddenTooltipComponent = ({ disabled, columnName, children }: Props) => {
  if (!disabled) {
    return <Fragment>{children}</Fragment>
  }

  return (
    <Tooltip
      placement="bottom-start"
      componentsProps={{ tooltip: { sx: { maxWidth: 360 } } }}
      title={
        <div css={tw`flex items-start gap-3 py-1`}>
          <div
            css={tw`flex items-center justify-center w-9 h-9 shrink-0 rounded-lg border border-solid border-[rgba(255, 255, 255, 0.16)]`}
          >
            <SvgIcon css={tw`w-5 h-5`}>
              <Columns3Minor color="white" />
            </SvgIcon>
          </div>
          <div>
            <Typography css={tw`mb-1`} variant="h6" color={colors.GRAY_WHITE}>
              Column hidden
            </Typography>
            <Typography variant="body2" color={colors.SHADES_GREY_300}>
              Enable the &quot;{columnName}&quot; column in Manage Columns to use this filter.
            </Typography>
          </div>
        </div>
      }
    >
      <span css={tw`inline-flex`}>{children}</span>
    </Tooltip>
  )
}

export const ColumnHiddenTooltip = memo(ColumnHiddenTooltipComponent)
